import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';
import appDataset from './appDataset'

Vue.use(Vuetify)

let dark = !(appDataset.theme == 'light')

export default new Vuetify({
  theme: {
    dark: dark,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: '#b2fa00',
        secondary: '#a1009a',
        accent: '#f54a1b',
        error: '#b2635e',
        warning: '#b6925d',
        info: '#5d90ae',
        success: '#85ac58'
      },
    },
  },
  lang: {
    locales: {
      de
    },
    current: 'de',
  },
});
